const SERVICE_DATA = {
    heading: "مجالات الممارسة",
    description: "نقدم المساعدة لعملائنا في مجموعة متنوعة من مجالات الممارسة، بما في ذلك المجالات الرئيسية للشركة في تقديم خدمات الدعاوى الشاملة أمام المحاكم الولائية والفيدرالية والوكالات الإدارية.",
    services_list: [
        {
            label: "التحكيم المدني",
            text: "إذا كنت متورطًا في نزاع مدني، فهناك عدة طرق قانونية متاحة لحل المسألة. يمكن أن تكون القوانين الولائية والفيدرالية في نيوجيرسي المتعلقة بهذه المسائل معقدة ومن الصعب التنقل فيها بمفردك. في مكتب مايتي إم. ماتوس للمحاماة ، يحتوي محامونا على عقود من الخبرة لمساعدتك في التنقل في عملية الدعوى المدنية.",
            icon: "pe-7s-news-paper",
        },

        {
            label: "الإصابات الشخصية",
            text: "نحن متخصصون في تمثيل المدعين في الإجراءات القضائية المتعلقة بالإصابات الشخصية. توجه خبرتنا الواسعة في هذا المجال العملاء من مرحلة الادعاء إلى مرحلة الدعوى في المحاكم الفيدرالية والولائية. لدينا ممارسة شاملة تركز على الاحتياجات الفردية لعملائنا.",
            icon: "pe-7s-drop"
        },
        {
            label: "بيع واستحواذ الأعمال التجارية",
            text: "يمكن لمحامينا أن يرشدوك خلال جميع مراحل التفاوض ، من الاتفاقيات الأولية إلى الإغلاق. نحافظ على تواصل وثيق مع عملائنا في كل مرحلة لضمان أن تظل الاعتبارات العملية واللوجستية في المسار الصحيح أثناء التفاوض وصياغة الوثائق اللازمة لتحديد التزامات كل طرف.",
            icon: "pe-7s-paper-plane"
        },
        {
            label: "الهجرة",
            text: "محامو الهجرة لدينا يعنون بقضايا الهجرة المتعلقة بالأسرة. نساعد المواطنين الأمريكيين، والمقيمين القانونيين في الولايات المتحدة، والمهاجرين واللاجئين الذين يسعون للالتقاء بأفراد أسرهم أو أحبائهم لتأمين تأشيرات هجرة أو خطيبة تعتمد على الأسرة. نمثل أيضًا المقيمين الدائمين في الولايات المتحدة الذين يسعون للتجنس",
            icon: "pe-7s-global"
        },
        {
            label: "الدفاع عن السائقين تحت تأثير الكحول",
            text: "تعد قوانين نيو جيرسي فيما يتعلق بالقيادة تحت تأثير الكحول (DWI، DUI) من بين الأكثر صرامة في الأمة، لذلك فمن المهم بشكل لا يمكن الاستغناء عنه الحصول على محامي خبير في الدفاع عن DWI في نيو جيرسي لتمثيلك إذا تم اتهامك بالقيادة تحت تأثير الكحول أو جرائم ذات الصلة في نيو جيرسي. يمتلك محامو الدفاع الجنائي في Maite M. Matos Law الخبرة في الدفاع عنك ضد تهم DWI والسعي للحصول على أفضل نتيجة ممكنة لحالتك.",
            icon: "pe-7s-car"
        },
        {
            label: "المحكمة البلدية",
            text: "الفريق القانوني في مكاتب مايتي إم. ماتوس يتضمن مدعين سابقين ومحامين الدفاع العام لديهم عقود من الخبرة في المحاكم البلدية في نيوجيرسي، بالإضافة إلى المحاكم العليا. إذا تم اعتقالك أو تغريمك في نيوجيرسي أنت أو أحد أفراد عائلتك.",
            icon: "pe-7s-culture"
        },
    ]
};

const TEAM_DATA = {
    title: 'من نحن',
    description: 'نساعد عملائنا في مجموعة متنوعة من مجالات الممارسة بما في ذلك المجالات الأساسية للشركة في تقديم خدمات الدعوى الشاملة أمام المحاكم الاتحادية والولائية والوكالات الإدارية.',
    team_list: [
        {
            profile: '/images/maite_matos.jpg',
            name: 'مايتي إم. ماتوس',
            designation: 'محامية',
            email: 'maite@mmatoslaw.com',
            bio: 'مايتي ماتوس (سابقاً مارتينيز-غيتا) تخرجت من كلية روتجرز في جامعة روتجرز وحصلت على درجة الدكتوراه في القانون (Juris Doctor) من كلية بنجامين إن. كاردوزو للقانون. كانت مساعدة قاضٍ للشرف السيد نستور غوزمان، المحكمة الجنائية. عملت في مكتب محاماة لأكثر من سبع سنوات حيث اكتسبت خبرة في مجالات متنوعة. ثم عملت في الحكومة المحلية للمقاطعة والبلدية لمدة عشر سنوات وركزت دائمًا على الدعاوى القضائية لأن تفضيلها هو أن تكون دائمًا في قاعة المحكمة. حاليًا تحتفظ بمنصب المستشار المساعد لشركة باترسون، حيث تكون أيضًا مدعيا عاما للمحكمة البلدية. هناك، تتعامل مع معظم المسائل المتعلقة بالقيادة تحت تأثير الكحول أو المخدرات خلال السنوات الثلاث الماضية، إذا لم تكن كلها. وهي أيضًا المدعي العام الرئيسي لبلدية مونتكلير وغالبًا ما تحل محل مدعي عام في البلديات من خلال مقاطعات إيسكس وباسايك. تأمل في إحضار خبرتها في باسايك وإيسكس إلى مقاطعة موريس. فلسفتها هي الاعتماد على نهج عملي وعدواني لتوفير خدمات قانونية عالية الجودة مع التركيز على احتياجات عملائها.'
        },
        {
            profile: '/images/Iman_Boukadoum2.jpg',
            name: 'إيمان بوكادوم',
            designation: 'محامية',
            email: 'iman@mmatoslaw.com',
            bio: 'إيمان بوكادوم هي خبيرة في قانون الهجرة والأسرة. وهي متخصصة في حالات اللجوء والوحدة العائلية. تخرجت بتفوق من جامعة فرجينيا وحصلت على درجة الدكتوراه في القانون من كلية ويليام وماري. وهي تتحدث اللغة العربية والفرنسية بطلاقة.',
        },
    ]
}


const MOCK_DATA = {
    SERVICE_DATA,
    TEAM_DATA
}

export default MOCK_DATA;